import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddAdditionalRequirements() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/AdditionalRequirementsLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Additional Requirements"
      alert="Additional Requirements Added Successfully"
      addDataAPIEndpoint="/AdditionalRe/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Additional Requirement",
              name: "ARL_Name",
              required: true, // Validation rule added here
              maxLength: 255,
            },
            {
              type: "select",
              label: "Status",
              name: "ARL_Status",
              required: true, // Validation rule added here
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        ARL_Name: {
          required: true,
        },
        ARL_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddAdditionalRequirements;
